import React from "react"
import { useDLScrollObserver } from "./utils/hooks"

export const WatcherDL = () => {
  // Необходимо указать ВСЕ компоненты и задать им нужный ID на родителя компонента, подробнее в DLScrollEvent
  useDLScrollObserver({
    ids: [
      "banner",
      "calculator",
      "benefits",
      "how_to_get_a_loan",
      "form",
      "switcher_content",
      "footer",
    ],
  })

  return <></>
}
